function ShopifyMappingService(ApiService) {
  'ngInject';
  const service = {};

  service.createMapping = function(shopifyForm, orgId, callbackFunc){
    ApiService.post(`/organizations/${orgId}/shopify_mappings.json`, shopifyForm, callbackFunc);
  };

  service.getShofyMapping = function(formData){
    formData = JSON.parse(JSON.stringify(formData));
    formData.api_v1_contact_id = formData.api_v1_contact.id;
    delete formData.api_v1_contact;
   formData.api_v1_shopify_mapping_acs_attributes.forEach(function(element) {
    element.api_v1_account_id = element.api_v1_account.id;
    delete element.api_v1_account;
    });
   return formData;
};

  service.getMapping = function(orgId, callbackFunc){
    ApiService.get(`/organizations/${orgId}/shopify_mapping.json`, callbackFunc);
  };

  service.deleteMapping = function(orgId, callbackFunc){
    ApiService.delete(`/organizations/${orgId}/shopify_mapping.json`, {}, callbackFunc);
  };

  service.getAccounts = function(orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/accounts.json`, callbackFunc);
  };

  service.getContacts = function(orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/contacts.json`, callbackFunc);
  };

  service.addNewContact = function(contactData, orgId, callbackFunc){
    ApiService.post(`/xero/create_contact`, {organization_id: orgId,contact_name: contactData }, callbackFunc);
  };

  return service;
}

export default{
  name: 'ShopifyMappingService',
  fn: ShopifyMappingService
};
